import apiProvider from './provider';
import { API_BASE_URL } from 'src/globals';
import {
  ORG_PROFILING_GET_MASTER,
  ORG_PROFILING_FETCH_ORG_DETAILS,
  ORG_PROFILING_UPDATE_PROFILE,
  ORG_PROFILING_FETCH_ORG_PROFILE_DETAILS,
  FETCH_ALL_USERS_OF_CURRENT_ORGANISATION,
  ORG_CONFIG_CONSIGNOR_ADDRESS,
  FETCH_ALL_USERS_BY_ORGANISATION_V2,
  FETCH_ALL_USERS_BY_ORGANISATION_V3,
  ORG_CURRENCY,
  ORG_CONFIG_DISTANCE_BETWEEN_ADDRESSES,
  ORG_CONFIG_CONSIGNOR_ADRESS_UPLOAD_SAMPLE_EXCEL,
  ORG_CONFIG_CONSIGNOR_ADRESS_UPLOAD_EXCEL,
  ORG_CONFIG_CONSIGNOR_ADRESS_UPDATE_EXCEL,
  ORG_CONFIG_DELETE_CONSIGNOR_ADDRESS,
  ORG_CONFIG_ENABLE_CONSIGNOR_ADDRESS,
  ORG_CONFIG_CONSIGNOR_ADDRESS_PAGINATED
} from './routes';
import { getAuthenticationHeaders, getErrorMessage } from './utils';
import { GET, POST, PATCH, UPDATE, DELETE, ApiResponseWrapper } from './apiHandler';
import { APIResponseType } from 'src/Library/Types';
import { SEConsignorAddress } from 'src/components/pages/shipment-execution/SE.interfaces';
import CreateEditAddressDTO from 'src/dto/request/createEditAddress';
import ApiDto from 'src/dto/ApiDto';
import { AxiosResponse } from 'axios';

export const fetchOrgMaster = async () => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(
      `${API_BASE_URL}${ORG_PROFILING_GET_MASTER}`,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchOrganisationDetails = async () => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(
      `${API_BASE_URL}${ORG_PROFILING_FETCH_ORG_DETAILS}`,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const updateOrgProfile = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${ORG_PROFILING_UPDATE_PROFILE}`,
      body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchOrgProfileDetails = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${ORG_PROFILING_FETCH_ORG_PROFILE_DETAILS}`,
      body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchUsers = async () => {
  return await POST(`${API_BASE_URL}${FETCH_ALL_USERS_OF_CURRENT_ORGANISATION}`, {});
};

export const fetchUsersV3 = () => {
  return GET(`${API_BASE_URL}${FETCH_ALL_USERS_BY_ORGANISATION_V3}`, { status: 'ACTIVE' });
};

export const fetchUsersV2 = async (params?: any) => {
  return POST(`${API_BASE_URL}${FETCH_ALL_USERS_BY_ORGANISATION_V2}`, params);
};

// TODO: Use DTO
export const fetchAddresses = (params?: any): Promise<
  APIResponseType<SEConsignorAddress[]>> => {
  
  const finalParams = { ...params }

  if (finalParams.fetchAll === true){
    finalParams.limit = -1
    delete finalParams.fetchAll
  }

  return GET(`${API_BASE_URL}${ORG_CONFIG_CONSIGNOR_ADDRESS}`, finalParams);
};

export const fetchAddressesPaginated = (params, signal?: AbortSignal) => {
  return GET(`${API_BASE_URL}${ORG_CONFIG_CONSIGNOR_ADDRESS_PAGINATED}`, params, undefined, undefined, signal);
}

export const createAddress = (body: typeof ApiDto.CreateConsignorAddressDto) => {
  return POST(`${API_BASE_URL}${ORG_CONFIG_CONSIGNOR_ADDRESS}`, body);
};

export const getAddress = (id, stakeholderId?: string) => {
  return GET(`${API_BASE_URL}${ORG_CONFIG_CONSIGNOR_ADDRESS}/${id}`, { stakeholderId });
};

export const getDistanceBetweenAddresses = (body) => {
  return POST(`${API_BASE_URL}${ORG_CONFIG_DISTANCE_BETWEEN_ADDRESSES}`, body);
}

export const updateAddress = (
  id,
  body: typeof ApiDto.UpdateConsignorAddressDto,
) => {
  return UPDATE(`${API_BASE_URL}${ORG_CONFIG_CONSIGNOR_ADDRESS}/${id}`, body);
};

export const getCurrencyList = (params?) => {
  return GET(`${API_BASE_URL}${ORG_CURRENCY}`, params)
}

export const downloadSampleAddressExcel = (isEdit: boolean) => {
  return GET(`${API_BASE_URL}${ORG_CONFIG_CONSIGNOR_ADRESS_UPLOAD_SAMPLE_EXCEL}`, {isEdit}, 'blob');
}

export const createBulkAdress = (params) => {
  return POST(`${API_BASE_URL}${ORG_CONFIG_CONSIGNOR_ADRESS_UPLOAD_EXCEL}`, params)
}

export const updateBulkAddress = (params) => {
  return POST(`${API_BASE_URL}${ORG_CONFIG_CONSIGNOR_ADRESS_UPDATE_EXCEL}`, params)
}

export const deleteConsignorAddress = (id) => {
  return DELETE(`${API_BASE_URL}${ORG_CONFIG_DELETE_CONSIGNOR_ADDRESS}/${id}`)
}

export const enableConsignorAddress = (id: string) => {
  return UPDATE(`${API_BASE_URL}${ORG_CONFIG_ENABLE_CONSIGNOR_ADDRESS(id)}`, {})
}
